let url = 'https://r.orange.fr/r/Oodc_oi_promo_win'
let text = 'Rien de plus facile ! Grâce au bouton Choisir orange.fr, vous ferez apparaître une fenêtre pour enregistrer un fichier. Double-cliquez ensuite sur ce fichier pour l’exécuter.'

if (o_idzone['OS_FAMILY'].toUpperCase() !== 'WINDOWS') { // eslint-disable-line
  if (o_idzone['BROWSER_FAMILY'].toUpperCase() === 'FIREFOX') { // eslint-disable-line
    url = 'https://r.orange.fr/r/Oodc_oi_promo_ff'
    text = 'Rien de plus facile ! Grâce au bouton Choisir orange.fr, vous ferez apparaître un message. Il suffira ensuite de cliquer sur Continuer l’installation puis sur Ajouter.'
  } else if (o_idzone['BROWSER_FAMILY'].toUpperCase() === 'CHROME') { // eslint-disable-line
    url = 'https://r.orange.fr/r/Oodc_oi_promo_ch'
    text = 'Rien de plus facile ! Cliquez sur Choisir orange.fr pour accéder à la page de l’extension, puis cliquez sur Ajouter à Chrome.'
  }
}

let segmentRefZ = typeof segmentationRefZ === 'undefined' ? false : segmentationRefZ // eslint-disable-line

const tpl = `<div class="site-width py-1 pl-xl-4 pl-lg-3 pl-md-2 alert-container alert-info"
                  data-oevent-category='orange-inside_preference3'
                  data-oevent-action='hors bouton'
                  data-oevent-label='www.orange.fr/portail'
                  data-oevent-other="{'track_refZ': 'acc-digital_${segmentRefZ}_orange-inside_preference3'}"
        >
        <p class="alert">
          <span class="alert-icon icon-info mr-1" aria-hidden="true"></span>
          <span class="text-mw">
            Retrouvez orange.fr en page de démarrage de votre navigateur
          </span>
        </p>
        <div class="alert-content ml-xl--1">
          <p class="alert-text">
          ${text}
          </p>
          <div class="d-inline-flex flex-row justify-content-lg-end">
            <button type="button" class="btn btn-secondary mr-2"
                data-oevent-category='orange-inside_preference1'
                data-oevent-action='non-merci'
                data-oevent-label='www.orange.fr/portail'
                data-oevent-other="{'track_refZ': 'acc-digital_${segmentRefZ}_orange-inside_preference1'}"
            >Non merci</button>
            <a href="${url}"
                data-oevent-category='orange-inside_preference2'
                data-oevent-action='choisir-orange.fr'
                data-oevent-label='${url}'
                data-oevent-other="{'track_refZ': 'acc-digital_${segmentRefZ}_orange-inside_preference2'}"
                class="btn btn-secondary">Choisir orange.fr</a>
          </div>
        </div>
    </div>`
const cookieConsentName = 'userconsent'
const cookieOrangeinsideName = 'hpc-orangeInside'

/* eslint-disable */
/**
 * Récupère la valeur d'un cookie
 * @param {string} sName Nom du cookie
 * @return {string | boolean} Contenu du cookie, false si le cookie n'est pas trouvé
 */
function hp_sGetCookie(sName) {
  var iStartPos
  var iEndPos

  if (document.cookie.length > 0) {
    iStartPos = document.cookie.indexOf(sName + '=')
    if (iStartPos !== -1) {
      iStartPos = iStartPos + sName.length + 1
      iEndPos = document.cookie.indexOf(';', iStartPos)
      if (iEndPos === -1) {
        iEndPos = document.cookie.length
      }
      return encodeURI(document.cookie.substring(iStartPos, iEndPos))
    }
  }
  return false
}

let consent = hp_sGetCookie(cookieConsentName)
let oic = hp_sGetCookie(cookieOrangeinsideName)
/* eslint-enable */

/**
 * remove the cookie indicating that the message can be displayed
 */
function cappingOic() {
  let expireDate = new Date()
  let nbDays = 21
  let age = 1000 * 60 * 60 * 24 * nbDays
  expireDate.setTime(expireDate.getTime() + age)
  document.cookie = cookieOrangeinsideName + '=1;expires=' + expireDate.toGMTString() + ';'
}

export default class OrangeInside {
  /**
   * display
   * @param {HTMLElement} element the dom node on which we instanciate the class
   * @param {object}      options all the options to initialise the class instance
   */
  display(element, options) {
    this.element = element

    // check if we can generate and display the node
    if (typeof (consent) !== 'undefined' && consent !== false) {
      if (oic !== '1') {
        setTimeout(() => {
          this.generate()
          // @see https://jira.si.fr.intraorange/browse/FTACCUEILV-1514
          // => we do the same job than the elcos script, and cross fingers to let it work :)
          document.getElementById('o-header').style.height = 'auto'
          /* eslint-disable */
          o_link({
            nonInteraction: true,
            track_zone: 'orange-inside_bandeau', // Category
            track_nom: 'affichage-bandeau', // Action
            track_cible: 'www.orange.fr/portail' // Label
          })
          /* eslint-enable */
          // when displayed, we can bind events
          this.bind()
        }, 1000)
      }
    } else {
      // force the message to be hidden (just in case it's not done in the template twig)
      this.onCloseMessage()
    }
  }

  /**
   * Generate the message and display the node
   */
  generate() {
    let template = this.element
    let afterElement = document.getElementById('o-accessibility')
    template.innerHTML = tpl
    afterElement.parentNode.insertBefore(template, afterElement.nextSibling)
    template.style.display = '' // force the message to be displayed
  }

  /**
   * Bind all the events necessary for orangeInside to work
   */
  bind() {
    document.addEventListener('click', () => {
      // when we click on the document, the message has to be hidden
      cappingOic()
      this.onCloseMessage()
    })

    this.element.addEventListener('click', (event) => {
      // when we click on the message, the message has to be hidden in all case
      // whatever the user clicked on yes or no
      // done here too just in case the event's propagation is stopped by another function
      event.stopPropagation()
      cappingOic()
      this.onCloseMessage()
    })
  }

  /**
   * Close the message
   */
  onCloseMessage() {
    this.element.style.display = 'none'
  }
}

OrangeInside.DEFAULTS = {}
